function hcOptLabel(i,v){var g=document.querySelector('[data-option="'+i+'"]');if(!g)return v;var bs=g.querySelectorAll('button[data-value]');for(var k=0;k<bs.length;k++){if(bs[k].getAttribute('data-value')===String(v))return bs[k].getAttribute('data-label')||v;}return v;}
/* HerCharm PDP page script. Moved out of sections/hc-nose-ring-pdp.liquid (a2-22).
   Liquid-dependent values come from the <script type="application/json" id="hc-data"> blob in the section.
   a2-24: every numbered feature block runs inside its own guard, so one failure cannot stop the rest. */

var HC_DATA = {};
try { HC_DATA = JSON.parse(document.getElementById('hc-data').textContent); } catch (e) { HC_DATA = {}; }

var HC_VARIANTS = HC_DATA.variants || [];
var hcSel = HC_DATA.sel || {};
var HC_CUR = HC_DATA.cur || '£';
var HC_MONEY_SAMPLE = HC_DATA.moneySample || '';
var HC_ASSET_BASE = HC_DATA.assetBase || '';

// a2-24: one failing block must not take the page (and ADD TO CART) down with it
function hcGuard(name, fn){
  try { fn(); }
  catch (e) { try { if (window.console && console.error) console.error('[hc-pdp] ' + name, e); } catch (_) {} }
}

// ---- 1. Announcement countdown: real end of the September sale (30 Sep 23:59:59 London = 22:59:59 UTC) ----
function pad(n){return String(n).padStart(2,'0')}

// ---- 13. Dispatch line: countdown on working days, next working day at weekends / UK bank holidays (a2-08) ----
var HC_HOLIDAYS={'2026-01-01':1,'2026-04-03':1,'2026-04-06':1,'2026-05-04':1,'2026-05-25':1,'2026-08-31':1,'2026-12-25':1,'2026-12-28':1,'2027-01-01':1,'2027-04-02':1,'2027-04-05':1,'2027-05-03':1,'2027-05-31':1,'2027-08-30':1,'2027-12-27':1,'2027-12-28':1};
function hcIsoDay(d){ return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate()); }
function hcWorkingDay(d){ var w=d.getDay(); return w!==0&&w!==6&&!HC_HOLIDAYS[hcIsoDay(d)]; }
function hcNextWorkingDay(from){ var d=new Date(from); do{ d.setDate(d.getDate()+1); }while(!hcWorkingDay(d)); return d; }
// Ivan, 20 Sep: the countdown runs every day, weekends and bank holidays included. Only the tail
// changes - on a day we do not pack, it names the day the order actually goes out.
function hcDispatchTail(now){
  if(hcWorkingDay(now)) return 'ships today';
  var D=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  return 'ships '+D[hcNextWorkingDay(now).getDay()];
}
function tickDispatch(){
  var box=document.querySelector('.dispatch'), el=document.getElementById('dispatch-timer');
  if(!box) return;
  if(document.hidden||!box.getClientRects().length) return; // fix25.9: no work while the tab or the line is not shown
  var now=new Date(), tail=hcDispatchTail(now);
  if(!el||box.getAttribute('data-tail')!==tail){
    box.innerHTML='Order within <b id="dispatch-timer">00:00</b> &middot; '+tail;
    box.setAttribute('data-tail',tail);
    el=document.getElementById('dispatch-timer');
  }
  var d=36e5-(now.getTime()%36e5);
  el.textContent=pad(Math.floor(d/6e4)%60)+':'+pad(Math.floor(d/1e3)%60);
}
hcGuard('13-dispatch', function(){
  tickDispatch(); setInterval(tickDispatch,1000);
  document.addEventListener('visibilitychange',tickDispatch);
});

// ---- 13b. Delivery estimate: today + 8 to 12 business days (Mon-Fri) ----
hcGuard('13b-eta', function(){
  var el=document.getElementById('hc-eta'); if(!el) return;
  function addBiz(d,n){ var x=new Date(d); while(n>0){ x.setDate(x.getDate()+1); var w=x.getDay(); if(w!==0&&w!==6) n--; } return x; }
  var now=new Date(), a=addBiz(now,8), b=addBiz(now,12);
  var M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'], D=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  function f(x){ return D[x.getDay()]+' '+x.getDate()+' '+M[x.getMonth()]; }
  el.innerHTML='Arrives <b>'+f(a)+' &ndash; '+f(b)+'</b>';
});

// ---- 7. Gallery: swipeable track, thumbs jump to slide ----
hcGuard('7-gallery', function(){
  var gtrack=document.getElementById('g-track');
  var thumbBtns=Array.prototype.slice.call(document.querySelectorAll('#g-thumbs button'));
  if(!gtrack) return;
  thumbBtns.forEach(function(btn,i){
    btn.addEventListener('click',function(){
      gtrack.scrollTo({left:i*gtrack.clientWidth,behavior:'smooth'});
    });
  });
  gtrack.addEventListener('scroll',function(){
    var idx=Math.round(gtrack.scrollLeft/gtrack.clientWidth);
    thumbBtns.forEach(function(b,j){b.classList.toggle('active',j===idx);if(j===idx)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});
  });
});

// ---- 35. Swipe rows: desktop chevron buttons scroll one card width ----
hcGuard('35-swipe', function(){
  document.querySelectorAll('.swipe-wrap').forEach(function(wrap){
    var row=wrap.querySelector('.swipe-row');
    if(!row) return;
    wrap.querySelectorAll('.swipe-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        var card=row.children[0];
        if(!card) return;
        var gap=parseFloat(getComputedStyle(row).columnGap)||parseFloat(getComputedStyle(row).gap)||12;
        var step=card.getBoundingClientRect().width+gap;
        row.scrollBy({left:btn.classList.contains('next')?step:-step,behavior:'smooth'});
      });
    });
  });
});

// ---- 19. UGC videos: autoplay all 5, always, looping, never paused (owner wants them moving the whole visit) ----
hcGuard('19-videos', function(){
  try{
    var vids=Array.prototype.slice.call(document.querySelectorAll('.ugc-row video'));
    if(!vids.length)return;
    function play(v){
      try{
        if(!v.getAttribute('src')&&v.dataset&&v.dataset.src){
          // a2-19: the small phone file on small screens, and only when the card is within one screen (autoplay itself is unchanged)
          var small=window.matchMedia&&window.matchMedia('(max-width: 767px)').matches;
          v.src=(small&&v.dataset.srcM)?v.dataset.srcM:v.dataset.src;
        }
        // pass12-3: everything stays muted except the one clip the visitor turned the sound on for
        if(window.HC_SND===v){ v.muted=false; v.removeAttribute('muted'); }
        else { v.muted=true; v.defaultMuted=true; v.setAttribute('muted',''); }
        v.loop=true; v.setAttribute('playsinline','');
        if(v.paused&&!document.hidden){var p=v.play(); if(p&&p.catch)p.catch(function(){});}
      }catch(e){}
    }
    function playAll(){vids.forEach(function(v){ if(v.getAttribute('src')) play(v); });}
    // load (and start) each clip when it is within one screen of the viewport; nothing downloads before that
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting) play(e.target); }); },{rootMargin:'100% 0px'});
      vids.forEach(function(v){ io.observe(v); });
    } else { vids.forEach(play); }
    vids.forEach(function(v){
      ['loadedmetadata','canplay'].forEach(function(ev){v.addEventListener(ev,function(){play(v);});});
      // resume if something pauses it (browser power saving, stall) while the page is visible
      v.addEventListener('pause',function(){setTimeout(function(){play(v);},300);});
      v.addEventListener('ended',function(){try{v.currentTime=0;}catch(e){}play(v);});
      v.addEventListener('stalled',function(){setTimeout(function(){play(v);},1500);});
      v.addEventListener('error',function(){
        setTimeout(function(){try{if(v.error){v.load();}}catch(e){}play(v);},3000);
      });
    });
    // iOS Low Power Mode blocks autoplay until the first gesture
    var gestures=['touchstart','scroll','click','keydown'];
    gestures.forEach(function(ev){window.addEventListener(ev,playAll,{passive:true,capture:true});});
    document.addEventListener('visibilitychange',function(){if(!document.hidden)playAll();});
    window.addEventListener('pageshow',playAll);
    window.addEventListener('load',playAll);
    // watchdog: anything paused or frozen gets nudged
    var last=vids.map(function(v){return v.currentTime;});
    setInterval(function(){
      if(document.hidden)return;
      vids.forEach(function(v,i){
        try{
          if(!v.getAttribute('src')) return; // a2-19: not loaded yet (still more than one screen away)
          if(v.paused){play(v);}
          else if(v.readyState>=3&&v.currentTime===last[i]){var t=v.currentTime;v.currentTime=t+0.01;play(v);}
          last[i]=v.currentTime;
        }catch(e){}
      });
    },3000);
  }catch(e){}
});

// ---- 19c. UGC sound: off by default, one clip at a time, muted again when it scrolls away ----
window.HC_SND = null;
hcGuard('19c-ugc-sound', function(){
  var cards = Array.prototype.slice.call(document.querySelectorAll('.ugc-row .u'));
  if(!cards.length) return;
  function sync(){
    cards.forEach(function(u){
      var v=u.querySelector('video'), b=u.querySelector('.u-snd');
      if(!v||!b) return;
      var on = (window.HC_SND===v) && !v.muted;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on?'true':'false');
      b.setAttribute('aria-label', on?'Turn sound off':'Turn sound on');
      var use=b.querySelector('use'); if(use) use.setAttribute('href', on?'#hci-snd-on':'#hci-snd-off');
    });
  }
  cards.forEach(function(u){
    var b=u.querySelector('.u-snd'), v=u.querySelector('video');
    if(!b||!v) return;
    b.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var turningOn = (window.HC_SND!==v) || v.muted;
      cards.forEach(function(o){ var ov=o.querySelector('video'); if(ov&&ov!==v){ ov.muted=true; } });
      window.HC_SND = turningOn ? v : null;
      if(turningOn){
        if(!v.getAttribute('src')&&v.dataset&&v.dataset.src){ v.src=v.dataset.src; }
        v.muted=false; v.removeAttribute('muted');
        // only a real autoplay block puts the sound back off; an AbortError from the keeper calling play() again must not
        if(v.paused){
          var p=v.play();
          if(p&&p.catch) p.catch(function(err){
            if(!err || err.name==='NotAllowedError'){ v.muted=true; window.HC_SND=null; sync(); }
          });
        }
      } else { v.muted=true; }
      sync();
    });
  });
  // the sound goes off again once that clip has scrolled fully out of sight (plain geometry: an
  // IntersectionObserver here also fired for cards that were still on screen and killed the sound)
  window.addEventListener('scroll', function(){
    var v=window.HC_SND; if(!v) return;
    var u=v.parentNode; if(!u) return;
    var r=u.getBoundingClientRect(), h=window.innerHeight||document.documentElement.clientHeight;
    if(r.bottom<=0 || r.top>=h){ v.muted=true; window.HC_SND=null; sync(); }
  }, {passive:true});
  sync();
});

// ---- 19b. UGC dots: one per video, follow the scroll position ----
hcGuard('19b-ugc-dots', function(){
  var ugcRow=document.querySelector('.ugc-row');
  var ugcDots=document.getElementById('ugc-dots');
  if(!ugcRow||!ugcDots) return;
  var ugcCards=Array.prototype.slice.call(ugcRow.children);
  function ugcStep(){
    var gap=parseFloat(getComputedStyle(ugcRow).columnGap)||parseFloat(getComputedStyle(ugcRow).gap)||10;
    return ugcCards[0].getBoundingClientRect().width+gap;
  }
  ugcCards.forEach(function(card,i){
    var d=document.createElement('button');
    d.type='button'; d.setAttribute('aria-label','Show video '+(i+1));
    if(i===0){d.className='on';d.setAttribute('aria-current','true');}
    d.addEventListener('click',function(){ugcRow.scrollTo({left:i*ugcStep(),behavior:'smooth'});});
    ugcDots.appendChild(d);
  });
  var ugcDotEls=Array.prototype.slice.call(ugcDots.children);
  function ugcSync(){
    var maxIdx=ugcCards.length-1;
    var atEnd=ugcRow.scrollLeft+ugcRow.clientWidth>=ugcRow.scrollWidth-4;
    var idx=atEnd?maxIdx:Math.min(maxIdx,Math.round(ugcRow.scrollLeft/ugcStep()));
    ugcDotEls.forEach(function(d,j){d.classList.toggle('on',j===idx);if(j===idx)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current');});
  }
  ugcRow.addEventListener('scroll',ugcSync,{passive:true});
  window.addEventListener('resize',ugcSync);
});

// ---- 21. Info band: opening a tab slides it fully into view ----
hcGuard('21-info-band', function(){
  var accRow=document.querySelector('.accordions');
  if(!accRow) return;
  accRow.querySelectorAll('details').forEach(function(d){
    d.addEventListener('toggle',function(){
      if(!d.open)return;
      accRow.querySelectorAll('details[open]').forEach(function(o){if(o!==d)o.open=false;});
      requestAnimationFrame(function(){
        var left=d.getBoundingClientRect().left-accRow.getBoundingClientRect().left+accRow.scrollLeft-8;
        accRow.scrollTo({left:Math.max(0,left),behavior:'smooth'});
      });
    });
  });
});

// ---- 6/14. Fit single-line elements on narrow screens ----
function fitOneLine(el,minPx){
  if(!el)return;
  el.style.fontSize='';
  var fs=parseFloat(getComputedStyle(el).fontSize);
  var guard=0;
  while(el.scrollWidth>el.clientWidth+1&&fs>minPx&&guard<40){fs-=0.5;el.style.fontSize=fs+'px';guard++;}
}
function fitAll(){
  fitOneLine(document.getElementById('hc-title'),17);
  fitOneLine(document.getElementById('hc-lowstock'),11);
  fitOneLine(document.querySelector('.price-main'),12);
  fitOneLine(document.getElementById('hc-gifts'),11);
}
hcGuard('6-14-fit', function(){
  fitAll();
  window.addEventListener('resize',fitAll);
  if(document.fonts&&document.fonts.ready){document.fonts.ready.then(fitAll);}
  window.addEventListener('load',fitAll);
});

// ---- 30b. Show more reviews (text reviews from hc-reviews.js) ----
var rvMore=document.getElementById('rv-more');
var rvGrid=document.querySelector('.rev-grid');
var rvCount=document.getElementById('rv-count');
var rvShown=0;
function rvStarHtml(r){var s='';for(var i=0;i<5;i++)s+=i<r?'&#9733;':'<span style="color:#ccc">&#9733;</span>';return s;}
function rvEsc(t){return String(t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
function rvTotal(){return window.HC_RTOTAL!=null?window.HC_RTOTAL:(6+((window.HC_REVIEWS||[]).length));}
function rvImg(name){return HC_ASSET_BASE+name;}
function rvRenderMore(){
  var data=window.HC_REVIEWS||[];
  var slice=data.slice(rvShown,rvShown+12);
  slice.forEach(function(r){
    var card=document.createElement('div');card.className='rev-card';
    var img=r.i?'<div class="rimg"><img loading="lazy" decoding="async" src="'+rvImg(r.i)+'?width=600" srcset="'+rvImg(r.i)+'?width=300 300w, '+rvImg(r.i)+'?width=600 600w" sizes="(min-width: 768px) 430px, 50vw" alt="Customer photo from '+rvEsc(r.n).replace(/"/g,'&quot;')+'"></div>':'';
    card.innerHTML=img+'<div class="rbody"><span class="stars">'+rvStarHtml(r.r)+'</span><h4>'+rvEsc(r.t).toUpperCase()+'</h4><p class="txt">'+rvEsc(r.x)+'</p><div class="variant">'+rvEsc(r.v)+'</div><div class="who">'+rvEsc(r.n)+'</div><div class="rdate">'+rvEsc(r.d)+'</div></div>';
    rvGrid.appendChild(card);
  });
  rvShown+=slice.length;
  if(rvCount)rvCount.textContent='Showing '+Math.min(6+rvShown,rvTotal())+' of '+rvTotal();
  if(rvShown>=data.length)rvMore.hidden=true;
}
function rvPhotos(){
  var wrap=document.getElementById('rev-photos'), grid=document.getElementById('rp-grid'); var ph=window.HC_PHOTOS||[];
  if(!wrap||!grid||!ph.length) return;
  grid.innerHTML=ph.map(function(f,i){return '<div class="rp"><img loading="lazy" decoding="async" src="'+rvImg(f)+'?width=400" alt="Customer photo '+(i+1)+'"></div>';}).join('');
  wrap.hidden=false;
}
function rvInit(){
  if(!window.HC_REVIEWS){ setTimeout(rvInit,300); return; }
  var based=document.getElementById('rv-based'); if(based) based.textContent='Based on '+rvTotal()+' Reviews';
  rvPhotos();
  if(rvShown===0) rvRenderMore();
}
hcGuard('30b-reviews', function(){
  if(!(rvMore&&rvGrid)||window.HC_REV_CUSTOM) return;
  rvMore.addEventListener('click',function(){
    if(!window.HC_REVIEWS){rvMore.textContent='LOADING...';setTimeout(function(){rvMore.textContent='SHOW MORE REVIEWS';rvRenderMore();},400);return;}
    rvRenderMore();
  });
  rvInit();
});

// ---- 3. Cart drawer lives in snippets/hc-cart-drawer.liquid (globals: cdShow, cdToast, cdFetch, hcMissingGifts, hcRefreshCount) ----
var hcForm=document.getElementById('hc-product-form');
// One add for everything: the chosen ring set + every free gift not already in the bag.
// FIX 20 (2026-09-17): splitting gifts into /cart/update.js was tested live and Shopify's web pixels still emit
// product_added_to_cart per gift (Meta AddToCart x4 either way), so the single add stays.
// a2-01: never assume an empty cart. Cart unknown -> add the ring only and let hcSyncGifts add the gifts after a good read.
function hcAddAll(){
  var fd=new FormData(hcForm); var ring={id:parseInt(fd.get('id'),10),quantity:parseInt(fd.get('quantity')||'1',10)};
  var duoCb=document.getElementById('hc-duo-cb'), duo=(duoCb&&duoCb.checked)?hcOtherMetalVariant():null;
  return hcReadCart().then(function(c){ return [ring].concat(hcMissingGifts(c)); }, function(){ return [ring]; }).then(function(items){
    if(duo) items.splice(1,0,{id:duo.id,quantity:1});
    if(window.hcFreePicks){ window.hcFreePicks().forEach(function(fid,fi){ items.splice(1+fi,0,{id:fid,quantity:1}); }); }
    var body={method:'POST',body:JSON.stringify({items:items})};
    return cdFetch('/cart/add.js',body).catch(function(){ return cdWait(800).then(function(){ return cdFetch('/cart/add.js',body); }); });
  });
}
var HC_NET_MSG='Connection hiccup. Please tap again.';
// a2-09: the other metal in the same size and gauge, one compact line. The 15 off comes from an automatic discount on 2+ sets.
function hcOtherMetalVariant(){
  var cur=null, id=parseInt((document.getElementById('hc-variant-id')||{}).value,10);
  for(var i=0;i<HC_VARIANTS.length;i++){ if(HC_VARIANTS[i].id===id){ cur=HC_VARIANTS[i]; break; } }
  if(!cur) return null;
  var other=String(cur.options[0]).toLowerCase()==='gold'?'silver':'gold';
  for(var j=0;j<HC_VARIANTS.length;j++){
    var v=HC_VARIANTS[j];
    if(String(v.options[0]).toLowerCase()===other && v.options[1]===cur.options[1] && v.options[2]===cur.options[2] && v.available) return v;
  }
  return null;
}
var HC_DUO_ENABLED=false; // a2-09: flip to true once the 'Second set discount' applies alongside the free-gift discount
function hcDuoSync(){
  var box=document.getElementById('hc-duo'); if(!box) return;
  if(!HC_DUO_ENABLED){ box.hidden=true; var cb=document.getElementById('hc-duo-cb'); if(cb) cb.checked=false; return; }
  var v=hcOtherMetalVariant();
  if(!v){ box.hidden=true; return; }
  box.hidden=false;
  var was=document.getElementById('hc-duo-was'), now=document.getElementById('hc-duo-now');
  var full=hcNum(v.price)*100, off=full-1500*(full/2995);
  if(was) was.textContent=hcFmtCents(full);
  if(now) now.textContent='+'+hcFmtCents(Math.round(off));
  box.querySelector('.hd-sub').textContent='6 more rings in '+v.options[0];
}
// a2-05: keep the chosen variant in the URL (back button / sharing) only at the moment she adds to cart
function hcSetUrlVariant(){ try{ var id=document.getElementById('hc-variant-id').value; var u=new URL(window.location.href); if(u.searchParams.get('variant')===id) return; u.searchParams.set('variant',id); history.replaceState(history.state,'',u.toString()); }catch(e){} }
function hcBusy(btn,on,label){ if(!btn) return; btn.disabled=on; btn.textContent=on?label:btn.getAttribute('data-label'); }
hcGuard('3-add-to-cart', function(){
  if(!hcForm) return;
  var atcB=hcForm.querySelector('.atc'), bnB=document.getElementById('hc-buy-now');
  if(atcB) atcB.setAttribute('data-label',atcB.textContent); if(bnB) bnB.setAttribute('data-label',bnB.textContent);
  hcForm.addEventListener('submit',function(e){
    if(!window.fetch) return; e.preventDefault();
    hcBusy(atcB,true,'ADDING...');
    hcAddAll().then(function(r){
      if(!(r&&r.status&&r.status>=400)) hcSetUrlVariant();
      hcBusy(atcB,false);
      if(r&&r.status&&r.status>=400){ cdToast(r.description||r.message||'Could not add to cart'); return; }
      cdShow();
    }).catch(function(){ hcBusy(atcB,false); cdToast(HC_NET_MSG); });
  });
  if(bnB){
    bnB.addEventListener('click',function(){
      if(!window.fetch){ hcForm.submit(); return; }
      hcBusy(bnB,true,'ONE MOMENT...');
      hcAddAll().then(function(r){
        if(r&&r.status&&r.status>=400){ hcBusy(bnB,false); cdToast(r.description||r.message||'Could not add to cart'); return; }
        // make sure the gifts are in before leaving for checkout
        return hcReadCart().then(hcSyncGifts).catch(function(){}).then(function(){ window.location.href='/checkout'; });
      }).catch(function(){ hcBusy(bnB,false); cdToast(HC_NET_MSG); });
    });
  }
  // back from checkout: buttons must not stay on "ADDING..." / "ONE MOMENT..."
  window.addEventListener('pageshow',function(){ hcBusy(atcB,false); if(bnB) hcBusy(bnB,false); });
});

// ---- 3b. Header: burger menu ----
hcGuard('3b-burger', function(){
  var hcNav=document.getElementById('hc-nav');
  var hcBurger=document.getElementById('hc-burger');
  if(!(hcNav&&hcBurger)) return;
  // fix21: focus moves into the menu, Tab stays inside, Escape closes, focus returns to the burger (window.hcDialog from the cart drawer snippet)
  function hcNavClose(back){ if(hcNav.hidden) return; hcNav.hidden=true; hcBurger.setAttribute('aria-expanded','false'); if(window.hcDialog) hcDialog.close(hcNav, back===false); }
  hcBurger.setAttribute('aria-expanded','false'); hcBurger.setAttribute('aria-controls','hc-nav');
  hcBurger.addEventListener('click',function(){ hcNav.hidden=false; hcBurger.setAttribute('aria-expanded','true'); if(window.hcDialog) hcDialog.open(hcNav, hcBurger); });
  document.getElementById('hc-nav-close').addEventListener('click',function(){ hcNavClose(); });
  hcNav.addEventListener('click',function(e){ if(e.target===hcNav) hcNavClose(); });
  hcNav.querySelectorAll('.hc-nav-jump').forEach(function(a){ a.addEventListener('click',function(){ hcNavClose(false); }); });
  var hcNavAtc=document.getElementById('hc-nav-atc');
  if(hcNavAtc){ hcNavAtc.addEventListener('click',function(e){ var m=document.querySelector('#hc-product-form .atc'); if(!m||m.disabled) return; e.preventDefault(); m.click(); }); }
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') hcNavClose(); });
});

// ---- 26b. How-to steps: one open at a time ----
hcGuard('26b-howto', function(){
  document.querySelectorAll('.ht-item').forEach(function(d){
    d.addEventListener('toggle',function(){
      if(!d.open) return;
      document.querySelectorAll('.ht-item[open]').forEach(function(o){ if(o!==d) o.open=false; });
    });
  });
});

// ---- 41. Write a review modal ----
hcGuard('41-review-modal', function(){
  var rvo=document.getElementById('rv-overlay');
  var rvOpen=document.getElementById('rv-open');
  if(!(rvo&&rvOpen)) return;
  function rvShow(){rvo.hidden=false;var f=rvo.querySelector('input[name="contact[name]"]');if(window.hcDialog){hcDialog.open(rvo,rvOpen,f);}else if(f){setTimeout(function(){f.focus();},50);}}
  function rvHide(){if(rvo.hidden)return;rvo.hidden=true;if(window.hcDialog)hcDialog.close(rvo);}
  rvOpen.addEventListener('click',rvShow);
  document.getElementById('rv-close').addEventListener('click',rvHide);
  rvo.addEventListener('click',function(e){if(e.target===rvo)rvHide();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')rvHide();});
  var rvStars=Array.prototype.slice.call(document.querySelectorAll('#rv-stars button'));
  var rvRating=document.getElementById('rv-rating');
  rvStars.forEach(function(b){
    b.addEventListener('click',function(){
      var n=parseInt(b.getAttribute('data-star'),10);
      rvStars.forEach(function(x,i){x.classList.toggle('on',i<n);});
      rvRating.value=n+' / 5 stars';
    });
  });
  if(document.getElementById('rv-posted')||/contact_posted=true/.test(location.search)||location.hash==='#hc-review-form'){
    rvShow();
    if(!document.getElementById('rv-posted')&&/contact_posted=true/.test(location.search)){
      var ok=document.createElement('div');ok.className='rv-ok';ok.textContent='Thank you! Your review has been sent to us and will be published after a quick check.';
      rvo.querySelector('form').insertBefore(ok,rvo.querySelector('form').firstChild);
    }
  }
});

// ---- 39. Sticky bottom CTA: show after passing buy button, hide at guarantee CTA ----
hcGuard('39-sticky', function(){
  var stickyBar=document.getElementById('sticky-atc');
  var atcBtn=document.querySelector('.atc');
  var claimSec=document.querySelector('.claim');
  if(!(stickyBar&&atcBtn&&'IntersectionObserver' in window)) return;
  var pastAtc=false, claimVis=false;
  // Visible from page load whenever the main ADD TO CART button is off screen (below or above), hidden at the claim box.
  function updSticky(){ stickyBar.hidden=!(pastAtc&&!claimVis); }
  new IntersectionObserver(function(en){
    pastAtc=!en[0].isIntersecting&&en[0].boundingClientRect.top<0;
    updSticky();
  },{threshold:0}).observe(atcBtn);
  if(claimSec){
    new IntersectionObserver(function(en){
      claimVis=en[0].isIntersecting;
      updSticky();
    },{threshold:0}).observe(claimSec);
  }
});

// ---- 38. Size guide modal ----
hcGuard('38-size-guide', function(){
  var sgo=document.getElementById('sg-overlay');
  var sgl=document.getElementById('size-guide-link');
  if(!(sgo&&sgl)) return;
  function sgHide(){if(sgo.hidden)return;sgo.hidden=true;if(window.hcDialog)hcDialog.close(sgo);}
  sgl.addEventListener('click',function(e){e.preventDefault();sgo.hidden=false;if(window.hcDialog)hcDialog.open(sgo,sgl);});
  sgo.addEventListener('click',function(e){if(e.target===sgo)sgHide();});
  sgo.querySelector('.sg-close').addEventListener('click',sgHide);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')sgHide();});
});

// ---- Product form: live variant selection ----
function hcNum(v){ return typeof v === 'string' ? parseFloat(v) : v / 100; }
function hcFmtCents(cents){
  var n = Math.round(Number(cents) || 0), s = HC_MONEY_SAMPLE || '', i = s.indexOf('1'), j = s.lastIndexOf('56');
  var mid = (i > -1 && j > i) ? s.slice(i, j + 2) : '', m = mid.match(/^1(\D?)234(\D?)56$/);
  if (!m) return (HC_DATA.cur || '') + (n / 100).toFixed(2);
  var pre = s.slice(0, i), suf = s.slice(j + 2), th = m[1], dec = m[2] || '.';
  var whole = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, th), frac = String(n % 100).padStart(2, '0');
  return pre + whole + dec + frac + suf;
}
function hcMoney(v){ return hcFmtCents(Math.round(hcNum(v) * 100)); }
function hcTrim(x){ return String(x == null ? '' : x).replace(/^\s+|\s+$/g, '').toLowerCase(); }
function hcUpdate(fromUser){
  var match = null;
  for (var i = 0; i < HC_VARIANTS.length; i++){
    var v = HC_VARIANTS[i];
    var ok = true;
    for (var j = 0; j < v.options.length; j++){ if (hcTrim(v.options[j]) !== hcTrim(hcSel[j])) { ok = false; break; } }
    if (ok){ match = v; break; }
  }
  var buyOk = !!(match && match.available);
  [document.querySelector('#hc-product-form .atc'), document.getElementById('hc-buy-now')].forEach(function(b){
    if (!b) return;
    if (!b.getAttribute('data-label')) b.setAttribute('data-label', b.textContent);
    b.disabled = !buyOk;
    b.textContent = buyOk ? b.getAttribute('data-label') : (match ? 'SOLD OUT' : 'UNAVAILABLE');
  });
  if (!match) return;
  document.getElementById('hc-variant-id').value = match.id;
  // a2-05: no address-bar change on picker taps (Meta counted every replaceState as a new PageView); see hcSetUrlVariant
  var p = document.getElementById('hc-price'); if (p) p.textContent = hcMoney(match.price);
  var c = document.getElementById('hc-cmp');
  var s = document.getElementById('hc-save');
  if (match.compare_at_price && hcNum(match.compare_at_price) > hcNum(match.price)){
    if (c){ c.hidden = false; c.textContent = hcMoney(match.compare_at_price); }
    if (s){ s.hidden = false; s.innerHTML = 'SAVE&nbsp;' + hcFmtCents(Math.round((hcNum(match.compare_at_price) - hcNum(match.price)) * 100)); }
  } else { if (c) c.hidden = true; if (s) s.hidden = true; }
}
hcGuard('11-pickers', function(){
  document.querySelectorAll('[data-option]').forEach(function(group){
    var idx = parseInt(group.getAttribute('data-option'), 10);
    group.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click', function(){
        group.querySelectorAll('button').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        hcSel[idx] = btn.getAttribute('data-value');
        var lab = document.getElementById('opt-name-' + idx);
        if (lab) lab.textContent = btn.getAttribute('data-label') || hcSel[idx];
        hcUpdate(true);
        hcMiniSync();
        hcDuoSync();
      });
    });
  });
  hcUpdate();
});

// ---- 39b. Mini buy boxes (sticky bar + bottom claim): same selection, real add to cart ----
function hcMiniMatch(){
  for (var i = 0; i < HC_VARIANTS.length; i++){
    var v = HC_VARIANTS[i], ok = true;
    for (var j = 0; j < v.options.length; j++){ if (hcTrim(v.options[j]) !== hcTrim(hcSel[j])) { ok = false; break; } }
    if (ok) return v;
  }
  return null;
}
function hcMiniSync(){
  var m = hcMiniMatch(), buyOk = !!(m && m.available);
  var hero = document.getElementById('g-hero');
  document.querySelectorAll('[data-option]').forEach(function(g){
    var gi = parseInt(g.getAttribute('data-option'), 10);
    g.querySelectorAll('button').forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-value') === hcSel[gi]); });
  });
  document.querySelectorAll('.hcl-lab').forEach(function(l){ var li = parseInt(l.getAttribute('data-idx'), 10); if (hcSel[li] != null) l.textContent = hcSel[li]; });
  var mainLabs = document.querySelectorAll('[id^="opt-name-"]');
  mainLabs.forEach(function(l){ var li = parseInt(l.id.replace('opt-name-', ''), 10); if (hcSel[li] != null) l.textContent = hcOptLabel(li, hcSel[li]); });
  document.querySelectorAll('.hc-mini, .hc-claim').forEach(function(box){
    box.querySelectorAll('select[data-mini-opt]').forEach(function(sel){
      var idx = parseInt(sel.getAttribute('data-mini-opt'), 10);
      if (hcSel[idx] != null) sel.value = hcSel[idx];
    });
    var img = box.querySelector('.hm-img, .hcl-img'); if (img && hero && hero.src && img.getAttribute('data-hero') !== hero.src){ if (img.classList.contains('hm-img')) { img.src = hero.src.replace(/([?&])width=\d+/, '$1width=160'); } else { if (hero.srcset) img.srcset = hero.srcset; img.src = hero.src; } img.setAttribute('data-hero', hero.src); }
    var now = box.querySelector('.hm-now, .hcl-now'), was = box.querySelector('.hm-was, .hcl-was'), sav = box.querySelector('.hcl-save');
    if (m){
      if (now) now.textContent = hcMoney(m.price);
      var hasCmp = m.compare_at_price && hcNum(m.compare_at_price) > hcNum(m.price);
      if (was){ was.hidden = !hasCmp; if (hasCmp) was.textContent = hcMoney(m.compare_at_price); }
      if (sav){ sav.hidden = !hasCmp; if (hasCmp) sav.innerHTML = 'SAVE&nbsp;' + hcFmtCents(Math.round((hcNum(m.compare_at_price) - hcNum(m.price)) * 100)); }
    }
    var b = box.querySelector('.hm-btn');
    if (b && !b.classList.contains('busy')){ b.disabled = !buyOk; b.textContent = buyOk ? b.getAttribute('data-label') : (m ? 'SOLD OUT' : 'UNAVAILABLE'); }
  });
}
hcGuard('39b-mini-buy', function(){
  document.querySelectorAll('.hc-mini select[data-mini-opt]').forEach(function(sel){
    sel.addEventListener('change', function(){
      var idx = parseInt(sel.getAttribute('data-mini-opt'), 10);
      hcSel[idx] = sel.value;
      document.querySelectorAll('[data-option="' + idx + '"] button').forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-value') === sel.value); });
      var lab = document.getElementById('opt-name-' + idx); if (lab) lab.textContent = hcOptLabel(idx, sel.value);
      hcUpdate(true);
      hcMiniSync();
    });
  });
  document.querySelectorAll('.hc-mini .hm-btn, .hc-claim .hm-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var mainAtc = document.querySelector('#hc-product-form .atc');
      if (!mainAtc || mainAtc.disabled) return;
      btn.classList.add('busy'); btn.disabled = true; btn.textContent = 'ADDING...';
      mainAtc.click();
      setTimeout(function(){ btn.classList.remove('busy'); hcMiniSync(); }, 1800);
    });
  });
  hcMiniSync();
  hcDuoSync();
  window.addEventListener('load', function(){ hcMiniSync(); hcDuoSync(); });
});
